<div class="modal-overlay" *ngIf="true" tabindex="0" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>My Settings</h2>
      <button class="close-btn" (click)="onClose()">
        <i class="fas fa-times"></i>
      </button>
    </div>
      
      <div class="modal-content">
        <!-- Loading State -->
        <div *ngIf="isLoading()" class="loading-container">
          <app-spinner [size]="40"></app-spinner>
          <p>Loading your settings...</p>
        </div>
  
        <!-- Settings Form -->
        <form *ngIf="!isLoading()" class="settings-form" (ngSubmit)="onSave()">
          <!-- Personal Info Section -->
          <div class="form-section" [class.expanded]="isSectionExpanded('personal-info')">
            <div class="section-header" (click)="toggleSection('personal-info')">
              <h3 class="section-title">1. Personal Info</h3>
              <i class="accordion-icon fas fa-chevron-down" [class.rotated]="isSectionExpanded('personal-info')"></i>
            </div>
            
            <div class="section-content" [class.expanded]="isSectionExpanded('personal-info')">
              <h4 class="subsection-title">Basic Info</h4>
              
              <div class="form-row">
                <div class="form-group">
                  <label for="firstName" class="form-label">First Name*</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    class="form-input"
                    [ngModel]="settings().firstName"
                    (ngModelChange)="onInputChange('firstName', $event)"
                    placeholder="Enter your first name"
                    required
                  />
                </div>
                
                <div class="form-group">
                  <label for="lastName" class="form-label">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    class="form-input"
                    [ngModel]="settings().lastName"
                    (ngModelChange)="onInputChange('lastName', $event)"
                    placeholder="Enter your last name"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="email" class="form-label">Email Address* (This will be the username)</label>
                <input
                  readonly
                  type="email"
                  id="email"
                  name="email"
                  class="form-input readonly"
                  [ngModel]="settings().email"
                  (ngModelChange)="onInputChange('email', $event)"
                  placeholder="Enter your email address"
                  required
                />
              </div>

              <h4 class="subsection-title">Job Info</h4>
              
              <div class="form-group">
                <label for="title" class="form-label">Title*</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  class="form-input"
                  [ngModel]="settings().title"
                  (ngModelChange)="onInputChange('title', $event)"
                  placeholder="Enter your job title"
                  required
                />
              </div>
<!-- 
              <div class="form-group">
                <label for="aboutMe" class="form-label">Talk to Me About</label>
                <textarea
                  id="aboutMe"
                  name="aboutMe"
                  class="form-textarea"
                  [ngModel]="settings().aboutMe"
                  (ngModelChange)="onInputChange('aboutMe', $event)"
                  placeholder="Tell us what you'd like to discuss..."
                  rows="4"
                ></textarea>
              </div> -->
            </div>
          </div>

          <!-- Contact Info Section -->
          <div class="form-section" [class.expanded]="isSectionExpanded('contact-info')">
            <div class="section-header" (click)="toggleSection('contact-info')">
              <h3 class="section-title">2. Contact Info</h3>
              <i class="accordion-icon fas fa-chevron-down" [class.rotated]="isSectionExpanded('contact-info')"></i>
            </div>
            <div class="section-content" [class.expanded]="isSectionExpanded('contact-info')">
              <div class="contact-profile-row">
                <div class="contact-info">
                  <div class="profile-section">
                    <div class="profile-photo-container">
                      <div class="photo-container-mini" *ngIf="settings().profilePhoto; else noPhotoMini" (click)="$event.stopPropagation()">
                        <img [src]="settings().profilePhoto" alt="Profile Photo" class="profile-image-mini" />
                        <div class="photo-overlay-mini">
                          <button type="button" class="photo-action-btn-mini edit-btn" (click)="editPhoto(); $event.stopPropagation()">
                            <i class="fas fa-edit"></i>
                          </button>
                          <button type="button" class="photo-action-btn-mini delete-btn" (click)="deletePhoto(); $event.stopPropagation()">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                      
                      <ng-template #noPhotoMini>
                        <div class="photo-placeholder-mini" (click)="uploadPhoto(); $event.stopPropagation()">
                          <div class="placeholder-circle-mini">
                            <i class="fas fa-user"></i>
                          </div>
                          <!-- <div class="photo-overlay-placeholder">
                            <button type="button" class="photo-action-btn-mini edit-btn" (click)="editPhoto(); $event.stopPropagation()">
                              <i class="fas fa-edit"></i>
                            </button>
                            <button type="button" class="photo-action-btn-mini delete-btn" (click)="deletePhoto(); $event.stopPropagation()">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div> -->
                        </div>
                      </ng-template>
                      
                      <div class="photo-info">
                        <!-- <div class="photo-actions">
                          <button type="button" class="photo-action-btn" (click)="editPhoto()">
                            <i class="fas fa-edit"></i>
                          </button>
                          <button type="button" class="photo-action-btn" (click)="deletePhoto()">
                            <i class="fas fa-trash"></i>
                            
                          </button>
                        </div> -->
                        <p class="photo-subtext">You can upload a JPG, GIF or PNG file (file size limit is 4 MB).
                        </p>
                      </div>
                    </div>
                    
                    <button type="button" class="upload-btn-mini" (click)="uploadPhoto(); $event.stopPropagation()">
                      <i class="fas fa-upload"></i>
                      Upload
                    </button>
                  </div>
                  
                  <div class="form-row">
                    <div class="form-group full-width">
                      <label for="phone" class="form-label">Phone number*</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        class="form-input"
                        [ngModel]="settings().phone"
                        (ngModelChange)="onInputChange('phone', $event)"
                        placeholder="Enter your phone number"
                        required
                      />
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="address" class="form-label">Address</label>
                    <textarea
                      id="address"
                      name="address"
                      class="form-textarea"
                      [ngModel]="settings().address"
                      (ngModelChange)="onInputChange('address', $event)"
                      placeholder="Enter your address"
                      rows="3"
                    ></textarea>
                  </div>

                  <div class="form-row">
                    <div class="form-group">
                      <label for="city" class="form-label">City</label>
                      <input
                        type="text"
                        id="city"
                        name="city"
                        class="form-input"
                        [ngModel]="settings().city"
                        (ngModelChange)="onInputChange('city', $event)"
                        placeholder="Enter City"
                        required
                      />
                    </div>
                    
                    <div class="form-group">
                      <label for="state" class="form-label">State</label>
                      <input
                        type="text"
                        id="state"
                        name="state"
                        class="form-input"
                        [ngModel]="settings().state"
                        (ngModelChange)="onInputChange('state', $event)"
                        placeholder="Enter State"
                        required
                      />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group">
                      <label for="postalCode" class="form-label">Postal Code</label>
                      <input
                        type="text"
                        id="postalCode"
                        name="postalCode"
                        class="form-input"
                        [ngModel]="settings().postalCode"
                        (ngModelChange)="onInputChange('postalCode', $event)"
                        placeholder="Enter Postal Code"
                      />
                    </div>
                    
                    <div class="form-group">
                      <label for="country" class="form-label">Country</label>
                      <input
                        type="text"
                        id="country"
                        name="country"
                        class="form-input"
                        [ngModel]="settings().country"
                        (ngModelChange)="onInputChange('country', $event)"
                        placeholder="Enter Country"
                      />
                    </div>
                  </div>
                </div>

                <!-- Hidden file input -->
                <input
                  type="file"
                  #fileInput
                  accept=".jpg,.jpeg,.gif,.png"
                  (change)="onFileSelected($event)"
                  style="display: none;"
                />
              </div>
            </div>
          </div>

          <!-- Preferences Section -->
          <div class="form-section" [class.expanded]="isSectionExpanded('preferences')">
            <div class="section-header" (click)="toggleSection('preferences')">
              <h3 class="section-title">3. Preferences</h3>
              <i class="accordion-icon fas fa-chevron-down" [class.rotated]="isSectionExpanded('preferences')"></i>
            </div>
            
            <div class="section-content" [class.expanded]="isSectionExpanded('preferences')">
              <div class="form-group" (click)="$event.stopPropagation()">
                <label for="defaultPage" class="form-label">When I login, show:</label>
                <ng-select
                  id="defaultPage"
                  name="defaultPage"
                  class="form-select"
                  [ngModel]="settings().redirectTo"
                  (ngModelChange)="onInputChange('defaultPage', $event)"
                  [items]="defaultPageOptions()"
                  bindLabel="label"
                  bindValue="value"
                  placeholder="Select default page"
                  [clearable]="false"
                  [searchable]="false"
                >
                </ng-select>
              </div>
            </div>
          </div>

          <!-- Notifications Section -->
          <div class="form-section" [class.expanded]="isSectionExpanded('notifications')">
            <div class="section-header" (click)="toggleSection('notifications')">
              <h3 class="section-title">4. Email Notifications</h3>
              <i class="accordion-icon fas fa-chevron-down" [class.rotated]="isSectionExpanded('notifications')"></i>
            </div>
            
            <div class="section-content" [class.expanded]="isSectionExpanded('notifications')">
              <!-- Email Templates List -->
              <div class="form-group" *ngIf="settings().mailTemplates && settings().mailTemplates!.length > 0">
                <label class="form-label">Email Notification Types</label>
                <div class="email-templates-list">
                  <div 
                    *ngFor="let template of settings().mailTemplates; let i = index" 
                    class="email-template-item"
                    [class.disabled]="isTemplateDisabled(template._id)">
                    
                    <div class="template-info">
                      <div class="template-name">{{ template.notificationName }}</div>
                    </div>
                    
                    <div class="template-toggle">
                      <div class="toggle-switch">
                        <input
                          type="checkbox"
                          [id]="'template-' + template._id"
                          [name]="'template-' + template._id"
                          class="toggle-input"
                          [checked]="!template.isDisabled"
                          (change)="onTemplateToggle(template._id, $event)"
                        />
                        <label [for]="'template-' + template._id" class="toggle-label">
                          <span class="toggle-slider"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Fallback message if no templates -->
              <div class="form-group" *ngIf="!settings().mailTemplates || settings().mailTemplates!.length === 0">
                <div class="no-templates-message">
                  <i class="fas fa-info-circle"></i>
                  <span>No email templates available</span>
                </div>
              </div>

              <!-- Email Time Selection -->
              <!-- <div class="form-group">
                <label for="emailTime" class="form-label">Email Daily Digest after</label>
                <div class="time-selection" (click)="$event.stopPropagation()">
                  <ng-select
                    id="emailTime"
                    name="emailTime"
                    class="form-select time-select"
                    [ngModel]="settings().emailTime"
                    (ngModelChange)="onInputChange('emailTime', $event)"
                    [items]="emailTimeOptions"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Select time"
                    [clearable]="false"
                    [searchable]="false"
                  >
                  </ng-select>
                </div>
              </div> -->
            </div>
          </div>

          <!-- Access Section -->
          <div class="form-section" [class.expanded]="isSectionExpanded('access')">
            <div class="section-header" (click)="toggleSection('access')">
              <h3 class="section-title">5. Access</h3>
              <i class="accordion-icon fas fa-chevron-down" [class.rotated]="isSectionExpanded('access')"></i>
            </div>
            
            <div class="section-content" [class.expanded]="isSectionExpanded('access')">
              <!-- <div class="form-group">
                <div class="toggle-row">
                  <div class="toggle-info">
                    <span class="toggle-status" [class.enabled]="settings().isActive" [class.disabled]="!settings().isActive">
                      {{ settings().isActive ? 'Active' : 'Not Active' }}
                    </span>
                  </div>
                  <div class="toggle-switch">
                    <input
                      type="checkbox"
                      id="isActive"
                      name="isActive"
                      class="toggle-input"
                      [ngModel]="settings().isActive"
                      (ngModelChange)="onInputChange('isActive', $event)"
                    />
                    <label for="isActive" class="toggle-label">
                      <span class="toggle-slider"></span>
                    </label>
                  </div>
                </div>
              </div> -->

              <div class="form-group" (click)="$event.stopPropagation()">
                <label for="accessLevel" class="form-label">Access Level</label>
                <ng-select
                  id="accessLevel"
                  name="accessLevel"
                  class="form-select"
                  [ngModel]="settings().accessLevel"
                  (ngModelChange)="onInputChange('accessLevel', $event)"
                  [items]="accessLevelOptions"
                  bindLabel="label"
                  bindValue="value"
                  placeholder="Select access level"
                  [clearable]="false"
                  [searchable]="false"
                >
                </ng-select>
              </div>
            </div>
          </div>
        </form>
      </div>
      
      <div class="modal-actions">
       
        
        <div class="footer-right">
          <button class="btn-save" (click)="onSave()" [disabled]="isSaving() || isLoading() || getChangedFieldsCount() === 0">
            <app-spinner *ngIf="isSaving()" [size]="20"></app-spinner>
            <span *ngIf="!isSaving()">
              Save changes
            </span>
            <!-- Debug: Show saving state -->
            <span *ngIf="isSaving()" style="display: none;">Saving...</span>
          </button>
          <button class="btn-cancel" (click)="onCancel()" [disabled]="isSaving()">
            Cancel
          </button>
        </div>
        <!-- <div class="footer-left">
          <div class="settings-info">
            <i class="wl_icon_hint hint-icon"></i>
            <span>Update your personal information</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>